document.addEventListener('DOMContentLoaded', function () {
  var svgContainer = document.getElementById('svgContainer');
  var animation = bodymovin.loadAnimation({
    renderer: 'canvas', // Enable canvas rendering
    wrapper: svgContainer,
    loop: true,
    autoplay: false,
    path: '/wp-content/themes/thecrazyones/assets/lottie/the_crazy_ones_fund_canvas.json',
  });

  // Colors to cycle through
  const colors = ['#0B28FF', '#9300FF', '#0bca01'];

  // Schedule for color changes (time in milliseconds : color index)
  const schedule = {
    500: 0, // At 0ms, use color at index 0
    5000: 1, // At 3000ms (3 seconds), use color at index 1
    10500: 2, // At 5000ms (5 seconds), use color at index 2
  };

  // Function to apply the schedule
  function applySchedule() {
    const container = document.body;

    // Iterate over the schedule
    for (const [time, colorIndex] of Object.entries(schedule)) {
      setTimeout(() => {
        // console.log( time, colors[colorIndex]);
        gsap.to(container, {
          backgroundColor: colors[colorIndex],
          duration: 1.5, // Transition duration
        });
      }, parseInt(time, 10));
    }
  }

  // Trigger animations when Lottie is ready
  animation.addEventListener('data_ready', () => {
    animation.play(); // Start Lottie animation
    // console.log('start schedule', 'on ready');
    applySchedule(); // Start the background animation schedule
  });

  // Reapply the schedule on each loop
  animation.addEventListener('loopComplete', () => {
    // console.log('start schedule', 'after loop');
    applySchedule();
  });
});
